import { Options, Resource, SuccessResponse } from 'services/api';
import {
  SalesforceMappingResponse,
  UpgradePlanPayload
} from 'src/services/api/types/upgradePlan';

import Company from './Company.service';

/**
 * Service for Upgrade Plan in Comadmin
 */
export default class UpgradePlan extends Company {
  private static instance: UpgradePlan;

  private constructor(options: Options) {
    /* istanbul ignore next */
    super(options);
  }

  /**
   * This returns the singleton instance of the class
   * @param {Options} options
   */
  public static getInstance(options: Options) {
    if (!this.instance) {
      this.instance = new this(options);
    }

    return this.instance;
  }

  /**
   * Create an upgrade plan request
   * @param {UpgradePlanPayload} payload
   */
  create(payload: UpgradePlanPayload) {
    const url = `${this.buildUrl(Resource.Upgrade)}/request`;
    return this.makeRequest<SuccessResponse, UpgradePlanPayload>({
      url,
      method: this._request.Post,
      data: payload
    });
  }

  /**
   * Get mapping of SF fields for upgrade request form
   */
  getSalesforceMapping() {
    return this.makeRequest<SalesforceMappingResponse>({
      url: `/api/v${this._api_version}/corporate-api/user-exp/leadgen/forms/leadgen`,
      method: this._request.Get
    });
  }
}
